export const CARTE_INTERETS_PAGE = {
  title: "Carte des lieux d’intérêt",
  eyebrow: "Découvrir la ville",
  description:
    "Retrouvez sur une seule carte les associations, commerces, artisans et services municipaux de la commune.",
  heroImageUrl: "https://www.fontenayvendee.fr/medias/2017/12/plan.jpg",
  crumbs: [
    { label: "Accueil", href: "/" },
    { label: "Découvrir la ville" },
    { label: "Carte des lieux d’intérêt" },
  ],
};

export const DEFAULT_CENTER = [44.88, -0.61];
export const DEFAULT_ZOOM = 13;

export const POINT_TYPES = {
  association: {
    key: "association",
    label: "Associations",
    singular: "Association",
    shortLabel: "Asso.",
    color: "#10B981",
    stroke: "#059669",
  },
  commerce: {
    key: "commerce",
    label: "Commerces",
    singular: "Commerce",
    shortLabel: "Commerce",
    color: "#F59E0B",
    stroke: "#D97706",
  },
  service: {
    key: "service",
    label: "Services municipaux",
    singular: "Service municipal",
    shortLabel: "Service",
    color: "#3B82F6",
    stroke: "#2563EB",
  },
};